(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vybes-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  function stopAll(root, except) {
    root.querySelectorAll('[data-reel]').forEach(function (card) {
      if (card === except) return;
      var v = card.querySelector('video');
      if (v && !v.paused) v.pause();
      card.classList.remove('is-playing');
      var b = card.querySelector('[data-reel-toggle]');
      if (b) b.setAttribute('aria-label', 'Play');
    });
  }
  document.querySelectorAll('[data-reels]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-reel]');
      if (!card || !root.contains(card)) return;
      var v = card.querySelector('video');
      if (!v) return;
      var btn = card.querySelector('[data-reel-toggle]');
      if (v.paused) {
        stopAll(root, card);
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
        card.classList.add('is-playing');
        if (btn) btn.setAttribute('aria-label', 'Pause');
      } else {
        v.pause();
        card.classList.remove('is-playing');
        if (btn) btn.setAttribute('aria-label', 'Play');
      }
    });
    root.querySelectorAll('[data-reel] video').forEach(function (v) {
      v.addEventListener('ended', function () {
        var card = v.closest('[data-reel]');
        if (card) card.classList.remove('is-playing');
      });
    });
    // Pause whatever is playing once it scrolls out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) return;
          var v = en.target.querySelector('video');
          if (v && !v.paused) { v.pause(); en.target.classList.remove('is-playing'); }
        });
      }, { threshold: 0.2 });
      root.querySelectorAll('[data-reel]').forEach(function (c) { io.observe(c); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
